export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=409c8a94160ae30168e60006919dea2000ff2bb14b&name=addToFolderEventAction!'